export const leadLabel = "Lead";
export const addLeadLabel = "Add Lead";
export const companyLabel = "Company Name";
export const contactNameLabel = "Contact Name";
export const leadTypeLabel = "Lead Type";
export const leadStatusLabel = "Lead Status";
export const leadDescriptionLabel = "Lead Description";
export const dateLabel = "Date";
export const startDateLabel = "Start Date";
export const endDateLabel = "End Date";
export const resetLabel = "Reset";
export const allStatuses = "All Statuses";
export const connectedProfile = "Connected Profile";
export const importExcel = "Import Excel";
export const selectExcel = "Select Excel File (.xlsx, .xls, .csv)";
export const importLeads = "Import Leads";
export const importLabel = "Import";
export const addedBy = "Added By";

export const ACCESSOR_KEYS = {
  SRNOLABEL: "Sr no.",
  SERIAL_NUMBER: "serial_number",
  COMPANY: "company_name",
  CONTACT_NAME: "contact_name",
  LEAD_TYPE: "lead_type",
  LEAD_STATUS: "lead_status",
  LEAD_DESCRIPTION: "lead_description",
  DATE: "date",
  ACTION: "action",
};

export const LEAD_STATUS_BADGE_MAP = {
  Cold: "primary",
  Hot: "info",
  "Very Hot": "warning",
  "Follow-Up": "danger",
};

export const LEAD_TYPE_OPTIONS = [
  { value: "Fixed", label: "Fixed" },
  { value: "Dedicated", label: "Dedicated" },
];

export const truncateText = (text, maxLength = 30) => {
  if (!text) return "-";
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};
